import React from 'react';
import { DndProvider } from 'react-dnd';
import { useSelector } from 'react-redux';
import Backend from 'react-dnd-html5-backend';
import cn from 'classnames';

import Modal from '../common/Modal';
import OpentokVideo from './OpentokVideo';
import VisitHeader from './Components/VisitHeader';
import { OTContextProvider } from '../../redux/opentok/context';
import { hasProviderProfileSelector } from '../../redux/context/selectors';
import { useOTScriptLoad } from '../../redux/opentok/hooks/useOTScriptLoad';
import { useVirtualVisit } from '../../redux/opentok/hooks/useVirtualVisit';
import styles from './styles.styl';

function VirtualVideoRoom() {
  const { viewOptions, callState } = useVirtualVisit();
  const {
    collapsed,
    opened,
    dragging,
    fullScreenView,
    toggleFullScreenView,
  } = viewOptions;
  const { otConfig, roomMeta, initialRoomPendingInvitations } = callState;
  const isProvider = useSelector(hasProviderProfileSelector);
  const { loaded } = useOTScriptLoad(opened);

  if (!opened || !loaded) return null;

  return (
    <Modal>
      <DndProvider backend={Backend}>
        <div
          className={cn(styles.root, {
            [styles.collapsed]: collapsed,
            [styles.dragging]: dragging,
          })}
        >
          <OTContextProvider
            config={otConfig}
            isProvider={isProvider}
            initialPendingInvitations={initialRoomPendingInvitations}
          >
            <VisitHeader collapsed={collapsed} roomDetails={roomMeta} />
            <OpentokVideo
              collapsed={collapsed}
              fullScreenView={fullScreenView}
              toggleFullScreenView={toggleFullScreenView}
            />
          </OTContextProvider>
        </div>
      </DndProvider>
    </Modal>
  );
}

export default VirtualVideoRoom;



// WEBPACK FOOTER //
// ./src/components/VirtualVideoRoom/index.jsx